import { Controller } from 'utils/stimulus';

export default class LessonCardController extends Controller {
  static targets = ['card'];

  get eventName() {
    return 'lesson opened';
  }

  get eventParams() {
    const { lessonDiscipline, lessonType } = this.cardTarget.dataset;

    return {
      discipline: lessonDiscipline,
      type: lessonType,
      content_source: ['Base']
    };
  }

  emitEvent() {
    if (this.hasEmittedEvent) {
      return;
    }

    const eventName = this.eventName;
    const data = this.eventParams;

    UserTracker.emit('event', {
      eventName,
      data
    });

    this.hasEmittedEvent = true;
  }

  onClick() {
    this.emitEvent();
  }
}
